module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog-tracking-notes",
    attrs: {
      "visible": _vm.visible,
      "before-close": _vm.exit,
      "show-close": false
    }
  }, [_c('h1', {
    staticClass: "ui header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s((_vm.room || {}).no)), _c('div', {
    staticClass: "sub header"
  }, [_vm._v("状态跟踪")])]), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.notes), function(row, i) {
    return (_vm.showChecked || !_vm.checked[i]) ? _c('div', {
      staticClass: "row",
      class: {
        semitrans: i === _vm.notes.length - 1 || row.state || !row.note
      }
    }, [_c('el-checkbox', {
      class: {
        invisible: i === _vm.notes.length - 1
      },
      attrs: {
        "disabled": _vm.frozen[i]
      },
      on: {
        "input": function($event) {
          _vm.oncheck(row, i)
        }
      },
      model: {
        value: (row.state),
        callback: function($$v) {
          _vm.$set(row, "state", $$v)
        },
        expression: "row.state"
      }
    }), _c('el-input', {
      attrs: {
        "disabled": _vm.frozen[i],
        "placeholder": i === _vm.notes.length - 1 ? "新增条目..." : (!row.note ? "[ 删除该项 ]" : "")
      },
      on: {
        "input": function($event) {
          _vm.onchange(row, i)
        }
      },
      model: {
        value: (row.note),
        callback: function($$v) {
          _vm.$set(row, "note", $$v)
        },
        expression: "row.note"
      }
    }), _c('el-select', {
      attrs: {
        "disabled": _vm.frozen[i],
        "multiple": "multiple",
        "placeholder": "标签"
      },
      model: {
        value: (row.tags),
        callback: function($$v) {
          _vm.$set(row, "tags", $$v)
        },
        expression: "row.tags"
      }
    }, _vm._l((_vm.tags), function(tag) {
      return _c('el-option', {
        key: tag,
        attrs: {
          "label": tag,
          "value": tag
        }
      })
    })), _c('div', {
      staticClass: "time",
      class: {
        invisible: i === _vm.notes.length - 1
      }
    }, [_vm._v(_vm._s(row._modifier) + " / " + _vm._s(_vm.$formatters.date.to_datetime_short(row.time_modified)))])], 1) : _vm._e()
  })), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "label": "显示已完成"
    },
    model: {
      value: (_vm.showChecked),
      callback: function($$v) {
        _vm.showChecked = $$v
      },
      expression: "showChecked"
    }
  }), _c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("取消")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7660a5b0","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/DialogTrackingNotes.vue
// module id = 376
// module chunks = 0